module.exports = __webpack_public_path__ + "img/qiayang-1.5d9589ce.jpg";